import Select from "components/select";
import { all } from "components/utils/comm";
import { ISelect } from "interface";
import { ILodList } from "interface/home";
import i18n from "locales/i18n";
import useLodStore from "store/lod";
type IProps = {
  lodList: ILodList[];
};
export default function LodNmSelct({ lodList }: IProps) {
  const lng = i18n.language;
  const lod = useLodStore((state) => state.lod);
  const setLod = useLodStore((state) => state.setLod);
  const list = lodList?.map((lod) => {
    return {
      [lng]: lod.lodNm,
      value: lod.lodNm,
      code: lod.lodNo,
      ...lod,
    };
  });

  const handleSelect = (item: ISelect) => {
    setLod(item);
  };

  const defaultValue = lod
    ? {
        code: lod?.code,
        value: lod?.value,
        ko: lod?.ko,
        en: lod?.en,
      }
    : { ...all, ko: "숙소 선택", en: "select lod" };

  return (
    <Select
      name={"lodNm"}
      styles="flex-1 h-6  border-1 radius-1 bg-white overflow-visible"
      options={list ?? []}
      defaultValue={defaultValue}
      isInitialData={false}
      onSelect={handleSelect}
    />
  );
}
